<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Posting Supply For Production" active>

                                <b-row v-if="hasFailedDataPostingSupplyForProduction">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPostingSupplyForProduction.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyForProductionsFailed" :fields="fieldsPostingSupplyForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyForProduction" :sort-desc.sync="sortDescPostingSupplyForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPostingSupplyForProduction.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyForProductions" :fields="fieldsPostingSupplyForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyForProduction" :sort-desc.sync="sortDescPostingSupplyForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Posting Supply Detail For Production" active>

                                <b-row v-if="hasFailedDataPostingSupplyDetailForProduction">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPostingSupplyDetailForProduction.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyDetailForProductionsFailed" :fields="fieldsPostingSupplyDetailForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyDetailForProduction" :sort-desc.sync="sortDescPostingSupplyDetailForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>
												<template #cell(postingDate)="row">
													{{ row.item.postingDate | moment("HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPostingSupplyDetailForProduction.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyDetailForProductions" :fields="fieldsPostingSupplyDetailForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyDetailForProduction" :sort-desc.sync="sortDescPostingSupplyDetailForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>
												<template #cell(postingDate)="row">
													{{ row.item.postingDate | moment("HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Posting Supply Case" active>

                                <b-row v-if="hasFailedDataPostingSupplyCase">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPostingSupplyCase.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyCasesFailed" :fields="fieldsPostingSupplyCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyCase" :sort-desc.sync="sortDescPostingSupplyCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPostingSupplyCase.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="postingSupplyCases" :fields="fieldsPostingSupplyCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPostingSupplyCase" :sort-desc.sync="sortDescPostingSupplyCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';
import PostingSupplyForProductionList from '@/models/PostingSupplyForProduction/PostingSupplyForProductionList';
import PostingSupplyForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyForProductionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPostingSupplyForProduction: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Picking Supply For Production", key: 'pickingSupplyForProductionWorkOrderSupply', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply Id", key: 'workOrderSupplyWorkOrderSupplyDate', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Id", key: 'workOrderProcessWorkOrderProcessNumber', sortable: false},
				{"class" : "th-status", "label" : "Line", key: 'lineCode', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply Date", key: 'workOrderSupplyDate', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPostingSupplyDetailForProduction: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetailMaterialPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Material Part", key: 'materialPartPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Supply", key: 'qtySupply', sortable: false},
				{"class" : "th-status", "label" : "Pic Picking", key: 'picPickingFirstName', sortable: false},
				{"class" : "th-status", "label" : "PicPenerima", key: 'picPenerimaFirstName', sortable: false},
				{"class" : "th-status", "label" : "Line", key: 'lineCode', sortable: false},
				{"class" : "th-status", "label" : "PostingDate", key: 'postingDate', sortable: false},
				{"class" : "th-status", "label" : "Area", key: 'areaCode', sortable: false},
				{"class" : "th-status", "label" : "Rack", key: 'rackCode', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPostingSupplyCase: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Posting Supply Detail For Production", key: 'postingSupplyDetailForProductionPickingSupplyForProductionDetail', sortable: false},
				{"class" : "th-status", "label" : "Picking Supply Detail For Production", key: 'pickingSupplyDetailForProductionMaterialPart', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},
				{"class" : "th-status", "label" : "Area", key: 'areaCode', sortable: false},
				{"class" : "th-status", "label" : "Rack", key: 'rackCode', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			postingSupplyForProductions : [],
			postingSupplyForProductionsFailed: [],
			postingSupplyForProductionId : '',
			sortByPostingSupplyForProduction: '',
			sortDescPostingSupplyForProduction: '',
			hasFailedDataPostingSupplyForProduction: false,
			totalFailedPostingSupplyForProduction: 0,
			totalSucceedPostingSupplyForProduction: 0,
			postingSupplyDetailForProductions : [],
			postingSupplyDetailForProductionsFailed: [],
			postingSupplyDetailForProductionId : '',
			sortByPostingSupplyDetailForProduction: '',
			sortDescPostingSupplyDetailForProduction: '',
			hasFailedDataPostingSupplyDetailForProduction: false,
			totalFailedPostingSupplyDetailForProduction: 0,
			totalSucceedPostingSupplyDetailForProduction: 0,

			postingSupplyCases : [],
			postingSupplyCasesFailed: [],
			postingSupplyCaseId : '',
			sortByPostingSupplyCase: '',
			sortDescPostingSupplyCase: '',
			hasFailedDataPostingSupplyCase: false,
			totalFailedPostingSupplyCase: 0,
			totalSucceedPostingSupplyCase: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('postingsupplyforproduction/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('postingsupplyforproduction/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPostingSupplyForProductionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPostingSupplyForProductionForUpload : async function() {
			let _this = this;
			this.$http.get('postingsupplyforproduction/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.postingSupplyForProductions = [];
_this.postingSupplyDetailForProductions = [];
_this.postingSupplyCases = [];


					if (response != null) {
						let result = response.data;
						_this.postingSupplyForProductions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPostingSupplyForProduction = _this.postingSupplyForProductions.length;

						_this.postingSupplyForProductionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPostingSupplyForProduction = true;
						_this.totalFailedPostingSupplyForProduction = 0;
						if(_this.postingSupplyForProductionsFailed == undefined || _this.postingSupplyForProductionsFailed.length === 0) _this.hasFailedDataPostingSupplyForProduction = false;
						if(_this.hasFailedDataPostingSupplyForProduction) _this.totalFailedPostingSupplyForProduction = _this.postingSupplyForProductionsFailed.length;
						_this.postingSupplyDetailForProductions = [];
						_this.postingSupplyDetailForProductionsFailed = [];
						_this.hasFailedDataPostingSupplyDetailForProduction = true;
						_this.totalSucceedPostingSupplyDetailForProduction = 0;
						result.forEach(function(element) {
							_this.postingSupplyDetailForProductions.push(...element.postingSupplyDetailForProduction.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPostingSupplyDetailForProduction = _this.postingSupplyDetailForProductions.length;

							_this.postingSupplyDetailForProductionsFailed.push(...element.postingSupplyDetailForProduction.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.postingSupplyDetailForProductionsFailed == undefined || _this.postingSupplyDetailForProductionsFailed.length === 0) _this.hasFailedDataPostingSupplyDetailForProduction = false;
							if(_this.hasFailedDataPostingSupplyDetailForProduction) _this.totalFailedPostingSupplyDetailForProduction = _this.postingSupplyDetailForProductionsFailed.length;
						});						_this.postingSupplyCases = [];
						_this.postingSupplyCasesFailed = [];
						_this.hasFailedDataPostingSupplyCase = true;
						_this.totalSucceedPostingSupplyCase = 0;
						result.forEach(function(element) {
							_this.postingSupplyCases.push(...element.postingSupplyCase.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPostingSupplyCase = _this.postingSupplyCases.length;

							_this.postingSupplyCasesFailed.push(...element.postingSupplyCase.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.postingSupplyCasesFailed == undefined || _this.postingSupplyCasesFailed.length === 0) _this.hasFailedDataPostingSupplyCase = false;
							if(_this.hasFailedDataPostingSupplyCase) _this.totalFailedPostingSupplyCase = _this.postingSupplyCasesFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'postingsupplyforproduction/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PostingSupplyForProduction.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPostingSupplyForProduction = new PostingSupplyForProductionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
